.publicBotsBody {
  height: 100vh;
  overflow-y: auto;
}

.listStatus {
  padding: 20px;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.botList {
  list-style: none;
  margin: 0;
  padding: 0;
}

.botListItem {
  display: flex;
  align-items: center;
  width: 100%;
  text-align: start;
}

.botInfo {
  width: 0;
  flex-grow: 1;
  margin-inline-start: 10px;
  padding-block: 8px;
  padding-inline-end: 20px;
}

.botHeadline {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.botName {
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.botLang {
  flex-shrink: 0;
  font-size: 0.8em;
  color: var(--contactEmailColor);
  border: 1px solid var(--contactEmailColor);
  border-radius: 8px;
  padding: 0 6px;
}

.botAdmin {
  color: var(--contactEmailColor);
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.botDescription {
  margin-top: 2px;
  font-size: 0.92em;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.consentText p {
  margin: 0 0 12px 0;
  line-height: 1.4;
}

.footerNote {
  padding: 10px 6px;
  font-size: 0.85em;
  color: var(--contactEmailColor);
}